var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", [_vm._v("Solicitudes de Cuadratura en Terreno")])],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "asignacionNoSeriado" },
        [
          _c(
            "v-card",
            [
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Patente",
                          "item-text": "patente",
                          "item-value": "patente",
                          items: _vm.filtro_patente,
                          clearable: "",
                          "prepend-icon": "local_shipping"
                        },
                        model: {
                          value: _vm.model_filtro_patente,
                          callback: function($$v) {
                            _vm.model_filtro_patente = $$v
                          },
                          expression: "model_filtro_patente"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("DatePicker", {
                        attrs: {
                          locale: "es-cl",
                          color: "primary",
                          label: "Fecha Inicio"
                        },
                        model: {
                          value: _vm.model_filtro_inicio,
                          callback: function($$v) {
                            _vm.model_filtro_inicio = $$v
                          },
                          expression: "model_filtro_inicio"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("DatePicker", {
                        attrs: {
                          locale: "es-cl",
                          color: "primary",
                          label: "Fecha Fin"
                        },
                        model: {
                          value: _vm.model_filtro_fin,
                          callback: function($$v) {
                            _vm.model_filtro_fin = $$v
                          },
                          expression: "model_filtro_fin"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex xs6 sm3 md2" }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c("div", { staticClass: "flex xs6 sm3 md1" }, [
                          _c(
                            "div",
                            { staticClass: "text-sm-center botones-filtros" },
                            [
                              _c(
                                "v-btn",
                                { on: { click: _vm.applyfilters } },
                                [
                                  _c("v-icon", [_vm._v("search")]),
                                  _vm._v("Filtrar")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Tecnico",
                          "item-text": "nombre_completo",
                          "item-value": "tecnico",
                          items: _vm.filtro_tecnico,
                          clearable: "",
                          "prepend-icon": "person"
                        },
                        model: {
                          value: _vm.model_filtro_tecnico,
                          callback: function($$v) {
                            _vm.model_filtro_tecnico = $$v
                          },
                          expression: "model_filtro_tecnico"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Serie",
                          "item-text": "serie",
                          "item-value": "serie",
                          items: _vm.filtro_serie,
                          clearable: "",
                          "prepend-icon": "category"
                        },
                        model: {
                          value: _vm.model_filtro_serie,
                          callback: function($$v) {
                            _vm.model_filtro_serie = $$v
                          },
                          expression: "model_filtro_serie"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Estado",
                          "item-text": "label",
                          "item-value": "idFinalizado",
                          items: _vm.filtro_finalizado,
                          clearable: "",
                          "prepend-icon": "task_alt"
                        },
                        model: {
                          value: _vm.model_filtro_finalizado,
                          callback: function($$v) {
                            _vm.model_filtro_finalizado = $$v
                          },
                          expression: "model_filtro_finalizado"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex xs6 sm3 md2" }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c("div", { staticClass: "flex xs6 sm3 md1" }, [
                          _c(
                            "div",
                            { staticClass: "text-sm-center botones-filtros" },
                            [
                              _c(
                                "v-btn",
                                { on: { click: _vm.cleanfilters } },
                                [
                                  _c("v-icon", [_vm._v("clear")]),
                                  _vm._v("Limpiar")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Cliente",
                          "item-text": "nombre",
                          "item-value": "rut_cliente",
                          items: _vm.filtro_cliente,
                          clearable: "",
                          "prepend-icon": "store"
                        },
                        model: {
                          value: _vm.model_filtro_cliente,
                          callback: function($$v) {
                            _vm.model_filtro_cliente = $$v
                          },
                          expression: "model_filtro_cliente"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c("div", {
                    staticClass: "flex xs12 sm6 md6",
                    attrs: { align: "lef" }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "flex xs12 sm6 md6",
                      attrs: { align: "right" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: { click: _vm.btn_exportar }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n            "),
                          _c(
                            "span",
                            {
                              staticClass: "importExportBtnTexto",
                              staticStyle: { "margin-right": "30px" }
                            },
                            [_vm._v("Exportar csv")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "gridcard rounded-card" },
                [
                  _c("MantenedorGridSinCodigo", {
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "funcionalidad-id": _vm.funcionalidad
                    }
                  })
                ],
                1
              ),
              _vm.ModalDetalleCuadra
                ? _c("modalVerDetalleCuadratura", {
                    attrs: {
                      show: _vm.ModalDetalleCuadra,
                      ID_CUADRATURA: _vm.CUADRATURA_SELECCIONADA,
                      ID_SOLICITUD: _vm.NUMERO_SOLICITUD_SELECCIONADA
                    },
                    on: {
                      modalverDetalleEmit: function($event) {
                        return _vm.ModalDetalleCuadra_callback($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm.showReporteGenerado
                ? _c("div", { staticClass: "wrap-evidencia" }, [
                    _c(
                      "div",
                      { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
                      [
                        _c("div", { staticClass: "modalEnvio-content" }, [
                          _c(
                            "div",
                            [
                              _c("div", { staticClass: "titleEvidencia" }, [
                                _c(
                                  "h2",
                                  { staticClass: "importExportBtnIcon" },
                                  [_vm._v("Reporte Solicitado")]
                                )
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "buttonClose buttonCloseEvidencia",
                                  attrs: { align: "right" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        flat: "",
                                        small: "",
                                        color: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeReporte()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { staticClass: "importExportBtnIcon" },
                                        [_vm._v("close")]
                                      ),
                                      _vm._v("  \n                  "),
                                      _c(
                                        "span",
                                        { staticClass: "importExportBtnTexto" },
                                        [_vm._v("Cerrar")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                                _c("div", { staticClass: "text-sm-center" }, [
                                  _c(
                                    "p",
                                    { staticStyle: { "margin-top": "40px" } },
                                    [_vm._v(_vm._s(_vm.texto_reporte))]
                                  )
                                ]),
                                _c("div", { staticClass: "text-sm-center" }, [
                                  _c(
                                    "p",
                                    { staticStyle: { "margin-top": "40px" } },
                                    [
                                      _vm._v(
                                        "\n                    Puede ver sus reportes en el menú\n                    "
                                      ),
                                      _c(
                                        "router-link",
                                        {
                                          staticStyle: {
                                            cursor: "pointer",
                                            "font-size": "13px"
                                          },
                                          attrs: {
                                            "active-class":
                                              "router-link-active",
                                            to: "/conecta-reportes"
                                          }
                                        },
                                        [_vm._v("Informes")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }